"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ApplicationHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debounce = _interopRequireDefault(require("lodash/fp/debounce"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AppMenu = require("./AppMenu");
var _ApplicationActionBar = require("./ApplicationActionBar");
var _MobileSubmoduleNavigation = require("./MobileSubmoduleNavigation");
var _useResizeObserver3 = _interopRequireDefault(require("../../hooks/useResizeObserver"));
var _NavItems = _interopRequireDefault(require("./NavItems"));
var _modulePropTypes = _interopRequireDefault(require("./modulePropTypes"));
var _MobileAppMenu = require("./MobileAppMenu");
var _excluded = ["homeRoute", "showHomeIcon", "label", "className", "appNavigator", "appNavigatorClassName", "appMenuItems", "navItems", "actionBarItems", "onToggleAppMenu"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SCREEN_SM = 768; // @screen-sm: 768px;

var ApplicationHeader = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var homeRoute = props.homeRoute,
    showHomeIcon = props.showHomeIcon,
    label = props.label,
    className = props.className,
    appNavigator = props.appNavigator,
    appNavigatorClassName = props.appNavigatorClassName,
    appMenuItems = props.appMenuItems,
    navItems = props.navItems,
    actionBarItems = props.actionBarItems,
    onToggleAppMenu = props.onToggleAppMenu,
    remainigProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var actionBarRef = (0, _react.useRef)();
  var _useResizeObserver = (0, _useResizeObserver3["default"])(),
    _useResizeObserver2 = (0, _slicedToArray2["default"])(_useResizeObserver, 2),
    navRef = _useResizeObserver2[0],
    contentRect = _useResizeObserver2[1].contentRect;
  (0, _react.useImperativeHandle)(ref, function () {
    return navRef;
  }, []);
  var getContentRect = (0, _react.useCallback)(function (key) {
    return contentRect && Math.round(contentRect[key]);
  }, [contentRect]);
  var containerWidth = getContentRect('width') || 0;
  var isMobileWidth = containerWidth <= SCREEN_SM;
  var hasActionBarItems = !(0, _isEmpty["default"])(actionBarItems);
  var classNames = (0, _classnames["default"])('ApplicationHeader', 'user-select-none', isMobileWidth && 'mobile', className && className);
  return /*#__PURE__*/_react["default"].createElement("nav", (0, _extends2["default"])({}, remainigProps, {
    className: classNames,
    ref: navRef
  }), isMobileWidth && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MobileAppMenu.MobileAppMenu, {
    showHomeIcon: showHomeIcon,
    homeRoute: homeRoute,
    appMenuItems: appMenuItems,
    appNavigator: appNavigator,
    onToggleAppMenu: onToggleAppMenu
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1-1-0 display-flex gap-10"
  }, /*#__PURE__*/_react["default"].createElement(_MobileSubmoduleNavigation.MobileSubmoduleNavigation, {
    className: "flex-1-1",
    label: label,
    navItems: navItems,
    actionBarItems: actionBarItems
  }), hasActionBarItems && /*#__PURE__*/_react["default"].createElement(Divider, null), /*#__PURE__*/_react["default"].createElement(_ApplicationActionBar.ApplicationActionBar, {
    className: "mobile",
    items: actionBarItems
  }))), !isMobileWidth && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar-header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "navbar-brand ".concat(showHomeIcon ? 'home-icon' : '')
  }, homeRoute)), label && /*#__PURE__*/_react["default"].createElement(_AppMenu.AppMenu, {
    label: label,
    key: "AppMenu",
    appMenuItems: appMenuItems,
    appNavigator: appNavigator,
    appNavigatorClassName: appNavigatorClassName,
    onToggleAppMenu: onToggleAppMenu
  }), (0, _isEmpty["default"])(navItems) && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "SubmoduleNavigation nav"
  }), !(0, _isEmpty["default"])(navItems) && /*#__PURE__*/_react["default"].createElement(_NavItems["default"], {
    key: "NavItems",
    navItems: navItems,
    containerWidth: containerWidth,
    actionBarItems: actionBarItems
  }), /*#__PURE__*/_react["default"].createElement(_ApplicationActionBar.ApplicationActionBar, {
    nodeRef: actionBarRef,
    items: actionBarItems
  })));
});
exports.ApplicationHeader = ApplicationHeader;
var Divider = function Divider() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "divider display-flex align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "width-3 height-20 bg-lighter"
  }));
};
var _default = ApplicationHeader;
exports["default"] = _default;
ApplicationHeader.defaultProps = {
  homeRoute: '',
  showHomeIcon: true,
  actionBarItems: [],
  onToggleAppMenu: function onToggleAppMenu() {}
};
ApplicationHeader.propTypes = {
  label: _propTypes["default"].node,
  className: _propTypes["default"].string,
  homeRoute: _propTypes["default"].node.isRequired,
  showHomeIcon: _propTypes["default"].bool,
  appMenuItems: _propTypes["default"].arrayOf(_modulePropTypes["default"]),
  appNavigator: _propTypes["default"].node,
  appNavigatorClassName: _propTypes["default"].string,
  navItems: _propTypes["default"].arrayOf(_modulePropTypes["default"]),
  actionBarItems: _propTypes["default"].arrayOf(_propTypes["default"].node),
  onToggleAppMenu: _propTypes["default"].func
};